
























































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import axios from "axios";
import { ProductData } from "../models/ProductData";
import { ProductVersionData } from "../models/ProductVersionData";
import ErrorDialog from "./ErrorDialog.vue";
import ProductVersionDialog from "./ProductVersionDialog.vue";
import RowActions from "./RowActions.vue";
import {
  EnumHelpers,
  ProductOrToolType,
  UsageType,
  LicensingType,
} from "../helpers/EnumHelpers";
import { ErrorHandlingHelpers } from "../helpers/ErrorHandlingHelpers";
import { FailureResponseData } from "../models/FailureResponseData";
import App from "../App.vue";
import fs from "fs";
import ActionsCard from "./ActionsCard.vue";
import TitleCard from "./TitleCard.vue";

@Component({
  components: {
    RowActions,
    ErrorDialog,
    ProductVersionDialog,
    ActionsCard,
    TitleCard,
  },
})
export default class ProductVersionsDialog extends App {
  public get getTitle() {
    return this.item.name + " Versions";
  }

  public get getHeaders() {
    if (this.$auth.canManage) {
      return this.headers;
    } else {
      return this.headers.filter((h) => h.text !== "Actions");
    }
  }
  @Prop({ default: false })
  public isShown!: boolean;
  @Prop({ required: true })
  public item!: ProductData;

  private privateIsShown: boolean = false;
  private errorDialogIsShown: boolean = false;
  private versionDialogIsShown: boolean = false;
  private versionDialogIsEditing: boolean = false;
  private versionDialogIsDuplicating: boolean = false;
  private versionToEdit: ProductVersionData = new ProductVersionData(
    "",
    "",
    "",
    new Date(),
    [],
    "",
    "",
    LicensingType.Other,
    0,
    true,
    0,
    []
  );
  private failure: FailureResponseData = new FailureResponseData();
  private headers = [
    { text: "Version", value: "name" },
    { text: "Actions", value: "actions" },
  ];

  private versions: Array<ProductVersionData> = [];
  @Watch("isShown")
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value;
  }
  @Watch("privateIsShown")
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.fetchProduct();
    } else {
      this.$emit("dialogClosed");
      this.loading = true;
    }
  }

  public cancelled(item) {
    this.privateIsShown = false;
    this.$emit("dialogCancelled");
  }

  private initiateEditVersion(item) {
    this.versionToEdit = item;
    this.versionDialogIsEditing = true;
    this.versionDialogIsDuplicating = false;
    this.versionDialogIsShown = true;
  }

  private initiateDuplicateVersion(item) {
    this.versionToEdit = item;
    this.versionDialogIsEditing = false;
    this.versionDialogIsDuplicating = true;
    this.versionDialogIsShown = true;
  }

  private async initiateDownloadVersion(item) {
    try {
      axios({
        url: `ProductVersions/fordeployment/${item.id}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        this.download(response.data, item.name, "pdd");
      });
    } catch (e) {
      this.failure = new FailureResponseData(e.message);
      this.errorDialogIsShown = true;
    }
  }
  private async initiateDownloadVersionChangesLog(item) {
    try {
      axios
        .get(`ProductVersions/fullchangeslog/${item.id}`)
        .then((response) => {
          this.download(response.data, item.name, "csv");
        });
    } catch (e) {
      this.failure = new FailureResponseData(e.message);
      this.errorDialogIsShown = true;
    }
  }

  private download(fileData, versionName, extension) {
    const fileURL = window.URL.createObjectURL(new Blob([fileData]));
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute(
      "download",
      `${this.item.name} ${versionName}.${extension}`
    );
    document.body.appendChild(fileLink);
    fileLink.click();
  }

  private editVersion(oldVersion, newVersion) {
    this.fetchProduct();
    oldVersion.name = newVersion.name;
  }
  private async deleteVersion(item) {
    try {
      let errorsOccurred: boolean = false;
      let errorObject: FailureResponseData = new FailureResponseData();
      await axios
        .delete<ProductData>(`ProductVersions/${item.id}`)
        .catch((error) => {
          errorsOccurred = true;
          errorObject = ErrorHandlingHelpers.getFailureMessage(error);
        });

      if (errorsOccurred) {
        this.failure = errorObject;
        this.errorDialogIsShown = true;
      } else {
        this.versions = this.versions.filter((v) => v !== item);
      }
    } catch (e) {
      this.failure = new FailureResponseData(e.message);
      this.errorDialogIsShown = true;
    }
  }

  private initiateAddVersion() {
    this.versionDialogIsEditing = false;
    this.versionDialogIsDuplicating = false;
    this.versionDialogIsShown = true;
  }

  private addVersion(item) {
    this.fetchProduct();
    this.versions.splice(0, 0, item);
  }

  private async fetchProduct() {
    try {
      this.versions = [];

      const resp = await axios.get<ProductData>(
        `Products/withlatest/${this.item.id}`
      );

      this.versions = resp.data.versions;
    } catch (e) {
      this.showError = true;
      this.errorMessage = `Error while loading tool versions: ${e.message}.`;
    }
    this.loading = false;
  }
}
